import * as React from 'react';
import TileKebabMenuItemSnackbar from '../tile-kebab-menu/TileKebabMenuItemSnackbar';
import HomeBaseTabs from './HomeBaseTabs';
import OptViewed from '../../homebase-optimization-test/OptViewed/ViewedVehiclesCarousel/OptViewed';
import UftYouLookedAt from '../../homebase-optimization-test/OptViewed/ViewedVehiclesCarousel/UftYouLookedAt';
import { appState } from '../../../../common/state/appState';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { KmxContainer } from '../../../../components/KmxContainer';
import ViewedVehiclesCarousel from '../../homebase-optimization-test/ViewedVehiclesCarousel';
import HomeOptimizationTestPromoBanner from '../../homebase-optimization-test/HomeOptimizationTestPromoBanner';
import { ContinueSearching } from '../../continue-searching/ContinueSearching';
import { YouMightLikeContainer } from '../../homebase-optimization-test/YouMightLikeContainer';

interface IHomeBaseHeroProps {
    fullStoryPageId: string;
    showOptTestContent: boolean;
}

interface IHomeBaseHeroState {
    dialogOpen: boolean;
    snackbarOpen: boolean;
    snackBarText: string;
}

export default class HomeBaseHero extends React.Component<IHomeBaseHeroProps, IHomeBaseHeroState> {
    constructor(props: IHomeBaseHeroProps) {
        super(props);

        this.state = {
            dialogOpen: false,
            snackbarOpen: false,
            snackBarText: '',
        };

        this.handleDialogOpen = this.handleDialogOpen.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        this.handleOpenSnackbar = this.handleOpenSnackbar.bind(this);
    }

    private handleDialogOpen() {
        this.setState({
            dialogOpen: true,
        });
    }

    private handleDialogClose() {
        this.setState({
            dialogOpen: false,
        });
    }

    private handleOpenSnackbar = (text: string): void => {
        this.setState({ snackBarText: text });
        this.setState({ snackbarOpen: true });
    };

    public render(): React.ReactNode {
        if (this.props.showOptTestContent) {
            return (
                <KmxContainer
                    maxWidth="xl"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        // TODO: This is the same as the default, remove when productionalizing homebase test
                        px: { xs: 3, sm: 5, md: 8 },
                        pt: 2,
                        pb: { xs: 5, sm: 0 },
                        ['.kmx-fab']: { display: 'none' },
                    }}
                >
                    <ContinueSearching />
                    <ViewedVehiclesCarousel />
                    <HomeOptimizationTestPromoBanner />
                    <YouMightLikeContainer variant="test" />
                </KmxContainer>
            );
        }

        const { enableUFTHome } = window.featureFlags;
        const serveUFTContentEnabled = appState.getState().serveUFTContent;

        return (
            <KmxContainer
                maxWidth="xl"
                sx={{
                    ...(serveUFTContentEnabled ? { pt: { xs: 3, sm: 4 } } : { px: { xs: 3, sm: 2 }, pt: { xs: 0 } }),
                    pb: serveUFTContentEnabled ? undefined : { xs: 5, sm: 0 },
                }}
            >
                {enableUFTHome ? (
                    <UftYouLookedAt />
                ) : (
                    <Box
                        sx={{
                            borderRadius: { xs: 2, sm: 2.5 },
                            backgroundImage: {
                                sm: 'url(/images/home/hero/homebase-tablet.webp)',
                                md: 'url(/images/home/hero/homebase-xl.webp)',
                            },
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                        id="home-base-hero"
                        className="home-base-hero"
                    >
                        <Stack
                            useFlexGap
                            spacing={{ xs: 1.5, sm: 2 }}
                            sx={{
                                height: { xs: '0%', sm: '100%' },
                                py: {
                                    xs: 0,
                                    sm: 4,
                                    md: 5,
                                },
                            }}
                        >
                            <Box sx={{ display: { sm: 'none' } }}>
                                <OptViewed />
                            </Box>

                            <Box sx={{ display: { xs: 'none', sm: 'block' }, overflowX: 'clip' }}>
                                <HomeBaseTabs onOpenSnackBar={this.handleOpenSnackbar} />
                            </Box>
                            <TileKebabMenuItemSnackbar
                                icon={undefined}
                                isOpen={this.state.snackbarOpen}
                                textLabel={this.state.snackBarText}
                                cancelAction={() => {
                                    this.setState({ snackbarOpen: false });
                                }}
                            />
                        </Stack>
                    </Box>
                )}
            </KmxContainer>
        );
    }
}
